const routeData = new Map<string, any>();

export class RouteDataService {
    provideRouteData(data: any): string {
        const key = Math.random().toString(36).substring(7);
        routeData.set(key, data);
        return key;
    }

    getRouteData(key: string): any {
        const data = routeData.get(key);
        routeData.delete(key);
        return data || {};
    }
}
